import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import React from 'react'

import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

dayjs.extend(isToday)

export const getJoinedDate = (date: string) => {
  if (dayjs(date).isToday()) {
    return <TimezonedDateString date={date} format="h:mma" withTimezoneAbbreviation={false} />
  }

  return <TimezonedDateString date={date} format="MMM D" />
}
